import { React, useEffect, useState, useContext } from "react";
import { MyContextProvider } from "../../../../../App";
import axios from "axios";
import { API_URL } from "../../../../../Constant";
import { GlobalLoading, showLoading } from "react-global-loading";
import {
  handleUserLevelAccessPermissions, getAllYears,
  shortMonthToFull, shortMonthToMonthNumber, validateRolesIIPManufacturing
} from "../../../../../Custom/Custom";
import { ToastContainer, toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { downloadFrQrIndexExcel } from "../../frQrIndexExcel";
import iipTitleData from '../../../../../iip.json';
import messages from '../../.././../../assets/Messages.json';



function FRQRReport() {

  const [years, setYears] = useState([]);
  const [yearProduction, setYearProduction] = useState("2024");
  const [monthProduction, setMonthProduction] = useState("AUG");
  const [yearProductionQuick, setYearProductionQuick] = useState("");
  const [monthProductionQuick, setMonthProductionQuick] = useState("");
  const [months, setMonth] = useState([]);
  const [quickReportGenerateList, setQetQuickReportGenerateList] = useState([]);
  const [allChecked, setAllChecked] = useState(false);
  const [checkedItems, setCheckedItems] = useState({});
  /** Multi-month selections: { 'AUG-2024': { month, year, items: { [industryCode]: row } } } */
  const [selectedByPeriod, setSelectedByPeriod] = useState({});
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const token = useContext(MyContextProvider).token;
  const decode_token = jwtDecode(token);
  const navigate = useNavigate();
  const storedLanguage = localStorage.getItem('language');
  const [buttonAccess, setButtonAccess] = useState({
    userLevel: "",
    roles: "",
    isVisible: false,
  });
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };




  const getPeriodKey = (month, year) => `${String(month || '').toUpperCase()}-${year}`;

  const formatPeriodLabel = (month, year) => {
    const m = String(month || '').trim().toUpperCase();
    const pretty = m ? `${m.charAt(0)}${m.slice(1).toLowerCase()}` : '';
    return `${pretty}-${year}`;
  };

  const PERIOD_CHIP_COLORS = ['#ff8c00', '#28a745', '#0d6efd', '#6f42c1', '#dc3545', '#20c997'];

  const selectedPeriodEntries = Object.entries(selectedByPeriod)
    .map(([key, value]) => ({
      key,
      month: value.month,
      year: value.year,
      items: Object.values(value.items || {}),
      count: Object.keys(value.items || {}).length,
    }))
    .filter((entry) => entry.count > 0)
    .sort((a, b) => {
      const ya = Number(a.year) || 0;
      const yb = Number(b.year) || 0;
      if (ya !== yb) return ya - yb;
      return String(a.month).localeCompare(String(b.month));
    });

  const totalSelectedCount = selectedPeriodEntries.reduce((sum, entry) => sum + entry.count, 0);

  const getAllSelectedIndustries = () =>
    selectedPeriodEntries.flatMap((entry) =>
      entry.items.map((item) => ({
        ...item,
        sourceMonth: entry.month,
        sourceYear: entry.year,
      }))
    );

  const syncPeriodSelection = (periodMonth, periodYear, nextCheckedMap, listRows) => {
    const key = getPeriodKey(periodMonth, periodYear);
    if (!periodMonth || !periodYear) return;

    const items = {};
    (listRows || []).forEach((row) => {
      if (nextCheckedMap[row.industryCode]) {
        items[row.industryCode] = row;
      }
    });

    setSelectedByPeriod((prev) => {
      const next = { ...prev };
      if (Object.keys(items).length === 0) {
        delete next[key];
      } else {
        next[key] = { month: periodMonth, year: periodYear, items };
      }
      return next;
    });
  };

  const handleRemoveSelectedIndustry = (periodKey, industryCode, industryName) => {
    const label = industryName
      ? `${industryName} (${industryCode})`
      : String(industryCode || '');
    const confirmed = window.confirm(
      `Are you sure you want to remove "${label}" from selected industries?`
    );
    if (!confirmed) return;

    setSelectedByPeriod((prev) => {
      const next = { ...prev };
      const period = next[periodKey];
      if (!period?.items) return prev;

      const items = { ...period.items };
      delete items[industryCode];

      if (Object.keys(items).length === 0) {
        delete next[periodKey];
      } else {
        next[periodKey] = { ...period, items };
      }

      // If nothing left, close preview modal
      const remaining = Object.values(next).reduce(
        (sum, p) => sum + Object.keys(p.items || {}).length,
        0
      );
      if (remaining === 0) {
        setShowPreviewModal(false);
      }

      return next;
    });

    // Uncheck in current table if same period is loaded
    const currentKey = getPeriodKey(monthProduction, yearProduction);
    if (currentKey === periodKey) {
      setCheckedItems((prev) => {
        const updated = { ...prev, [industryCode]: false };
        const allItemsChecked =
          quickReportGenerateList.length > 0 &&
          quickReportGenerateList.every((row) => updated[row.industryCode] === true);
        setAllChecked(allItemsChecked);
        return updated;
      });
    }

    toast.success('Industry removed from selection.', messages.COLOR_RED);
  };


  useEffect(() => {
    const level = handleUserLevelAccessPermissions(decode_token);
    setButtonAccess(level);

    const userRole = async () => {
      showLoading(true);
      try {
        const role = await validateRolesIIPManufacturing(jwtDecode(token));
        if (!role) {
          alert("You are not an authorized for IIP Report");
          navigate("/dashboard");
        } else {
          setYears(getAllYears());
          getMonthsList();
        }
      } catch (error) {
        console.log(error);
        showLoading(false);
      }
    };

    //Get all Months data
    const getMonthsList = (e) => {
      showLoading(true);
      axios
        .get(`${API_URL}api/graph/getMonths/2019`, config)
        .then((res) => {
          let monthDataResponse = res.data;
          if (monthDataResponse.status) {
            setMonth(monthDataResponse.data);
            showLoading(false);
          }
        })
        .catch((err) => {
          console.error(err);
          showLoading(false);
        });
    };

    userRole();


  }, []);





  const handleDropdownChange = (e) => {

    switch (e.target.name) {

      case "monthProduction":
        setMonthProduction(e.target.value);
        setYearProduction('');

        break;
      case "yearProduction":


        let currentYear = new Date().getFullYear();
        let selectedYear = parseInt(e.target.value)

        if (selectedYear > currentYear) {
          toast.error('Invalid Year Selection.', messages.COLOR_RED);
          return false;
        } else if (selectedYear === currentYear) {

          let currentMonth = new Date().getMonth() + 1;
          let selectedMonth = shortMonthToMonthNumber(monthProduction);
          currentMonth = currentMonth < 10 ? `0${currentMonth}` : currentMonth;
          if (selectedMonth > currentMonth) {
            toast.error('Invalid Month Selection.', messages.COLOR_RED);
            setMonthProduction('')
            setYearProduction('')
            return false;
          }
        }
        setYearProduction(e.target.value);


        break;
      case "monthProductionQuick":
        setMonthProductionQuick(e.target.value);
        break;
      case "yearProductionQuick":
        let currentYearQuick = new Date().getFullYear();
        let selectedYearQuick = parseInt(e.target.value)

        if (selectedYearQuick > currentYearQuick) {
          toast.error('Invalid Year Selection.', messages.COLOR_RED);
          return false;
        } else if (selectedYearQuick === currentYearQuick) {

          let currentMonth = new Date().getMonth() + 1;
          let selectedMonth = shortMonthToMonthNumber(monthProductionQuick);
          currentMonth = currentMonth < 10 ? `0${currentMonth}` : currentMonth;
          if (selectedMonth > currentMonth) {
            toast.error('Invalid Month Selection.', messages.COLOR_RED);
            setYearProductionQuick('');
            setMonthProductionQuick('');
            return false;
          }
        }

        setYearProductionQuick(e.target.value);

        break;
      default:
        console.log("switch case are not match");
        break;
    }
  };


  // get QuickReport GenerateList
  const handleGetQRReportData = async () => {
    if (!monthProduction || !yearProduction) {
      toast.error('Please select Month and Year.', messages.COLOR_RED);
      return;
    }

    let postData = {
      Month: monthProduction,
      Year: yearProduction
    }
    showLoading(true);
    try {
      const response = await axios.post(`${API_URL}api/iipReports/getQuickReportGenerateList`, postData, config);
      const allData = response.data.data.GroupCodes;
      if (allData.length > 0) {
        setQetQuickReportGenerateList(allData);
        const periodSel = selectedByPeriod[getPeriodKey(monthProduction, yearProduction)]?.items || {};
        const restored = {};
        allData.forEach((row) => {
          if (periodSel[row.industryCode]) {
            restored[row.industryCode] = true;
          }
        });
        setCheckedItems(restored);
        setAllChecked(
          allData.length > 0 && allData.every((row) => restored[row.industryCode] === true)
        );
      } else {
        setQetQuickReportGenerateList([]);
        setAllChecked(false);
        setCheckedItems({});
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      showLoading(false);
    }
  }


  // Index Report Excel — selected industries replicated onto Quick month and saved to archive
  const handleGenerateReport = async () => {
    if (monthProductionQuick === '') {
      toast.error('Invalid quick Month Selection.', messages.COLOR_RED);
      return false;
    }
    if (yearProductionQuick === '') {
      toast.error('Invalid quick Year Selection.', messages.COLOR_RED);
      return false;
    }

    const selectedIndustries = getAllSelectedIndustries();

    if (selectedIndustries.length === 0) {
      toast.error('Check the checkboxes', messages.COLOR_RED);
      return false;
    }

    showLoading(true);

    try {
      const replicateIndustries = selectedIndustries.map((item) => ({
        industryCode: item.industryCode,
        sourceMonth: item.sourceMonth || monthProduction,
        sourceYear: item.sourceYear || yearProduction,
      }));

      const response = await axios.post(
        `${API_URL}api/iipReports/getQuickReportGenerateListSaveToDB`,
        {
          month: monthProductionQuick,
          year: yearProductionQuick,
          saveToDb: true,
          replicateIndustries,
        },
        config
      );

      if (!response.data?.status) {
        toast.error(response.data?.message || 'No data found for report.', messages.COLOR_RED);
        return false;
      }

      const monthForExcel = response.data?.data?.currentMonthData?.month || monthProductionQuick;
      const yearForExcel = response.data?.data?.currentMonthData?.year || yearProductionQuick;
      await downloadFrQrIndexExcel(
        response.data?.data?.MonthlyReportDataList,
        monthForExcel,
        yearForExcel
      );
      toast.success('Index report generated and saved to archive.', messages.COLOR_RED);
    } catch (error) {
      console.error('Error generating report:', error);
      toast.error(error?.message || 'Failed to generate report.', messages.COLOR_RED);
    } finally {
      showLoading(false);
    }
  };




  // Handle All check Box Change ******************
  const handleSelectAllChange = (event) => {
    const checked = event.target.checked;
    setAllChecked(checked);
    const updatedCheckedItems = {};
    quickReportGenerateList.forEach((item) => {
      updatedCheckedItems[item.industryCode] = checked;
    });
    setCheckedItems(updatedCheckedItems);
    syncPeriodSelection(monthProduction, yearProduction, updatedCheckedItems, quickReportGenerateList);
  };



  // Handle  check Box Change ******************
  const handleItemChange = (event) => {
    const item = event.target.name;
    const checked = event.target.checked;
    const updatedCheckedItems = { ...checkedItems, [item]: checked };
    setCheckedItems(updatedCheckedItems);
    const allItemsChecked =
      quickReportGenerateList.length > 0 &&
      quickReportGenerateList.every(
        (row) => updatedCheckedItems[row.industryCode] === true
      );
    setAllChecked(allItemsChecked);
    syncPeriodSelection(monthProduction, yearProduction, updatedCheckedItems, quickReportGenerateList);
  };



  return (
    <>
      <GlobalLoading />
      <ToastContainer />
      <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
          <div className="card-body pb-1">
            <div className="row align-items-center">
              <h4 className="page_heading">
                <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? iipTitleData.hi.FR_QR_REPORT : iipTitleData.en.FR_QR_REPORT }} />
              </h4>
              <div className="row align-items-center">
                <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                  <label>Month</label>
                  <select
                    name="monthProduction"
                    className="form-select"
                    onChange={handleDropdownChange}
                    value={monthProduction}
                  >
                    <option value="" disabled> Select Month</option>
                    {months &&
                      months.map((ele, i) => (
                        <option key={i} value={ele.MONTH}>
                          {shortMonthToFull(ele.MONTH)}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                  <label>Year</label>
                  <select
                    name="yearProduction"
                    className="form-select"
                    onChange={handleDropdownChange}
                    value={yearProduction}
                  >
                    <option value="" disabled> Select Year </option>
                    {years &&
                      years.map((ele, index) => (
                        <option key={index} value={ele}>
                          {ele}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-12 mb-3">
                  <label className="w-100 d-none d-sm-block">&nbsp;</label>
                  <button type="submit" className="btn btn_orange" onClick={(e) => handleGetQRReportData(e)}>Get Data</button>
                </div>

                <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                  <label>Quick Month</label>
                  <select
                    name="monthProductionQuick"
                    className="form-select"
                    onChange={handleDropdownChange}
                    value={monthProductionQuick}
                  >
                    <option value="" disabled> Select Month</option>
                    {months &&
                      months.map((ele, i) => (
                        <option key={i} value={ele.MONTH}>
                          {shortMonthToFull(ele.MONTH)}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                  <label>Quick Year</label>
                  <select
                    name="yearProductionQuick"
                    className="form-select"
                    onChange={handleDropdownChange}
                    value={yearProductionQuick}
                  >
                    <option value="" disabled> Select Year </option>
                    {years &&
                      years.map((ele, index) => (
                        <option key={index} value={ele}>
                          {ele}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-12 mb-3">
                  <label className="w-100 d-none d-sm-block">&nbsp;</label>
                  <button
                    type="submit"
                    className="btn btn_orange"
                    onClick={(e) => handleGenerateReport(e)}
                  >
                    Generate Report
                  </button>
                </div>

              </div>


            </div>
          </div>
        </div>
        <div className="card mx-3 mb-3">
          <div className="card">
            <div className="card-body">

              {totalSelectedCount > 0 && (
                <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
                  <strong className="me-1">Selected Months Summary:</strong>
                  {selectedPeriodEntries.map((entry, idx) => (
                    <span
                      key={entry.key}
                      className="badge rounded-pill px-3 py-2"
                      style={{
                        backgroundColor: PERIOD_CHIP_COLORS[idx % PERIOD_CHIP_COLORS.length],
                        color: '#fff',
                        fontWeight: 600,
                        fontSize: '0.85rem',
                      }}
                    >
                      {formatPeriodLabel(entry.month, entry.year)} ({entry.count})
                    </span>
                  ))}
                  <span
                    className="badge rounded-pill px-3 py-2"
                    style={{
                      backgroundColor: '#e7f1ff',
                      color: '#0d6efd',
                      border: '1px solid #b6d4fe',
                      fontWeight: 600,
                      fontSize: '0.85rem',
                    }}
                  >
                    Total Selected : {totalSelectedCount}
                  </span>
                  <button
                    type="button"
                    className="btn btn-sm d-inline-flex align-items-center gap-1"
                    onClick={() => setShowPreviewModal(true)}
                    style={{
                      borderRadius: '20px',
                      padding: '6px 14px',
                      backgroundColor: '#5c636a',
                      borderColor: '#5c636a',
                      color: '#fff',
                    }}
                  >
                    <i className="fa fa-eye" aria-hidden="true"></i>
                    Preview ({totalSelectedCount})
                  </button>
                </div>
              )}

              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Sr. No</th>
                      <th>Division Name</th>
                      <th>District Name</th>
                      <th>Industry Code</th>
                      <th>Industry Name</th>
                      <th className="text-center">
                        <input
                          type="checkbox"
                          checked={allChecked}
                          onChange={handleSelectAllChange}
                        />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {quickReportGenerateList.length > 0 &&
                      quickReportGenerateList.map((item, index) => {

                        return <>
                          <tr key={index}>
                            <td>{++index}</td>
                            <td>{item.divisionName}</td>
                            <td>{item.districtName}</td>
                            <td>{item.industryCode}</td>
                            <td>{item.industryName}</td>
                            <th className="text-center">
                              <input
                                type="checkbox"

                                name={item.industryCode}
                                checked={checkedItems[item.industryCode] || false}
                                onChange={handleItemChange}
                              />
                            </th>
                          </tr>
                        </>
                      })}

                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div>


      </div>

      {showPreviewModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          style={{ backgroundColor: 'rgba(0,0,0,0.45)' }}
          onClick={() => setShowPreviewModal(false)}
        >
          <div
            className="modal-dialog modal-lg modal-dialog-scrollable"
            role="document"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Selected Industries Preview ({totalSelectedCount})
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setShowPreviewModal(false)}
                />
              </div>
              <div className="modal-body">
                {selectedPeriodEntries.map((entry, idx) => (
                  <div key={entry.key} className="mb-3">
                    <div className="d-flex align-items-center gap-2 mb-2">
                      <span
                        className="badge rounded-pill px-3 py-2"
                        style={{
                          backgroundColor: PERIOD_CHIP_COLORS[idx % PERIOD_CHIP_COLORS.length],
                          color: '#fff',
                        }}
                      >
                        {formatPeriodLabel(entry.month, entry.year)} ({entry.count})
                      </span>
                    </div>
                    <div className="table-responsive">
                      <table className="table table-sm table-bordered mb-0">
                        <thead>
                          <tr>
                            <th>Sr. No</th>
                            <th>Division</th>
                            <th>District</th>
                            <th>Industry Code</th>
                            <th>Industry Name</th>
                            <th className="text-center">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {entry.items.map((item, i) => (
                            <tr key={`${entry.key}-${item.industryCode}-${i}`}>
                              <td>{i + 1}</td>
                              <td>{item.divisionName}</td>
                              <td>{item.districtName}</td>
                              <td>{item.industryCode}</td>
                              <td>{item.industryName}</td>
                              <td className="text-center">
                                <button
                                  type="button"
                                  className="btn btn-sm"
                                  title="Delete"
                                  onClick={() =>
                                    handleRemoveSelectedIndustry(
                                      entry.key,
                                      item.industryCode,
                                      item.industryName
                                    )
                                  }
                                  style={{
                                    backgroundColor: '#F47720',
                                    borderColor: '#F47720',
                                    color: '#fff',
                                  }}
                                >
                                  <i className="fa fa-trash" aria-hidden="true"></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ))}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn_orange"
                  onClick={() => setShowPreviewModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

    </>
  )
}

export default FRQRReport